/**
* Created By: Jennifer Mancilla
* Creation Date: 14/09/2022
* PBI: 78286 - Vista Paso 1 Cotizador Bepensa
*
* Last Modifier:
* Last Modification: 
*
* Feat: 
*
* version: 1.0.0
* copyright: 2022 INDUSTRIAS RESSER S.A DE C.V
*/
import React, { useState, useEffect } from 'react';
import { useAppSelector } from '../hooks/storeHooks';
import { Colors, Fonts } from '../utils/constants';
import {
    Checkbox,
    Row,
    message
} from 'antd';
import { Tooltip, Grid, Card, CardContent, CardMedia, CardActions, CardActionArea, Typography} from '@mui/material';
import { QuestionCircleOutlined } from '@ant-design/icons';
import {
    valueIcon,
    firstStepContainer,
    contentTxt, 
    txtCard,
    selectOptionFormTxt
} from '../styles/StepsStyles';
import {
    getUserActivo,
    getUserPlazo,
    getAssetPrice,
    getPurchaseOption,
    getPlazo,
    getLeasingType,
    getAssetDownPayment
} from '../reducer/slices/DataCotizador';
import { setLeasingObjPlazo, setObjCanalArrendamiento } from '../reducer/slices/DataResponse';
import { useAppDispatch } from '../hooks/storeHooks';
import { InputDefault, InputSelect, InputPrice } from '../components/Inputs/Inputs';
import GetModel from '../apis/ApiModel';
import GetVersion from '../apis/ApiVersion';
import { GetCanalDigitalID } from '../apis/ApiCanalDigital';
import SliderEnganche from '../components/Slider/SliderEnganche';
import { getAnalytics, logEvent } from '@firebase/analytics';
import InputAutocomplete from '../components/Inputs/Autocomplete';
import styles from '../styles/Step.style';
import ComponentPrice from '../components/Price/ComponentPrice';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
const useStyle = styles;

const arrayLeasingType = [
    { id: 0, name: "Arrendamiento automóviles PROCAAR" },
    // { id: 1, name: "Arrendamiento Puro" },
];

export const FirstStepArrendamiento = () => {
    const classes = useStyle();
    const Spacing = window.innerHeight < 950 ? 2 : 4;
    const { width } = useAppSelector(state => state.dimensions);
    const dispatch: any = useAppDispatch();
    const [checkedMin, setCheckedMin] = useState(false);
    const [checkedEst, setCheckedEst] = useState(false);
    const [checkedMax, setCheckedMax] = useState(false);
    const dataCotizador = useAppSelector(state => state.DataCotizador);
    const { validateFirstStep } = useAppSelector(state => state.Validates);
    const { filteredObjActivo, LeasingObjPlazo, ObjCanalArrendamiento } = useAppSelector(state => state.DataResponse);
    const residualPlazo = ObjCanalArrendamiento?.find(
        (e) => e.PlazoMeses === dataCotizador.plazo
    );
    const analytics = getAnalytics();
    const resetFields = () => {
        dispatch(getAssetPrice(0));
        dispatch(getPurchaseOption("_"));
        dispatch(getUserPlazo(0));
        dispatch(getPlazo(12));
        setCheckedMin(false);
        setCheckedEst(false);
        setCheckedMax(false);
      };
      
    useEffect(() => {
        resetFields();
    }, [dataCotizador.quoteType])

    useEffect(() => {
        logEvent(analytics, "view_first_screen");
    }, [])

    const onChangeMin = (e: any) => {
        const value: "ResidualEstandar" | "ResidualMaximo" | "ResidualMinimo" | "_" = e.target.value;
        if (value === "ResidualMinimo") {
            setCheckedMin(true);
            setCheckedEst(false);
            setCheckedMax(false);
        }
        if (value === "ResidualEstandar") {
            setCheckedMin(false);
            setCheckedEst(true);
            setCheckedMax(false);
        }
        if (value === "ResidualMaximo") {
            setCheckedMin(false);
            setCheckedEst(false);
            setCheckedMax(true);
        }
        dispatch(getPurchaseOption(value));
    }


    const onChangeUserActivo = async (value: any) => {
          dispatch(getUserActivo(value)); 
          GetCanalDigitalID(value).then((res: any) => {
            let objLeasingPlazo: { id: number, name: string }[] = [];
            res.items.map((res: any, index: number) => objLeasingPlazo.push({ id: index, name: res.PlazoMeses }));
            dispatch(setLeasingObjPlazo(objLeasingPlazo));
            dispatch(setObjCanalArrendamiento(res.items));
            dispatch(getUserActivo(value));
          })
          resetFields();;
          
      };

    

    const MIN_ASSET_PRICE = 200000;
    const onChangePrice = (value: string) => value === "" ? dispatch(getAssetPrice(undefined)) : dispatch(getAssetPrice(+value));

    const onChangePlazo = (value: any) => {
        dispatch(getPlazo(+LeasingObjPlazo.filter(e => e.id === value)[0].name))
        dispatch(getUserPlazo(value))
    };

    const onChangeLeasingType = (value: number) => {
        dispatch(getLeasingType(value));
    }

    const [verCotizacion, setDesglose] = useState<boolean>(false);
    return (
        <>
            <Row className={classes.firstStepContainer}>
                <p className={classes.selectActiveTxt} style={{marginBottom:'24px', }}>Selecciona tu activo</p>
                <Grid container spacing={Spacing} style={{ marginBottom: 30 }}>
                    <Grid item xs={12} sm={6} style={{display:'none'}}>
                        <InputSelect
                            label="Tipo de arrendamiento"
                            setValue={onChangeLeasingType}
                            value={dataCotizador.leasingType}
                            listItems={arrayLeasingType} />
                    </Grid>
                    <Grid item xs={12}>
                        <InputSelect
                            label="Tipo de activo"
                            setValue={onChangeUserActivo}
                            value={dataCotizador.userActivo}
                            listItems={filteredObjActivo} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputPrice
                            value={dataCotizador.assetPrice}
                            label="Precio del activo con IVA"
                            onChange={onChangePrice}
                            isNumber
                        isPrice />
                        {dataCotizador.assetPrice !== undefined && dataCotizador.assetPrice > 0 && dataCotizador.assetPrice < MIN_ASSET_PRICE && (
                            <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                No se alcanza el monto mínimo de $200,000 MXN
                            </p>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputSelect
                            label="Plazo solicitado"
                            setValue={onChangePlazo}
                            value={dataCotizador.userPlazo}
                            listItems={LeasingObjPlazo} />
                    </Grid>
                    <Grid item xs={12} >
                        <SliderEnganche />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <p style={{ textAlign:'center'}} className={classes.subtitleTxt}>
                            Valor de opción de compra garantizada al término del arrendamiento
                            <Tooltip
                                placement={width <= 700 ? "top" : "right"}
                                enterTouchDelay={0}
                                leaveTouchDelay={5000}
                                title='El valor residual es el precio que un arrendatario tiene que pagar por ser dueño del activo.'
                            >
                                <QuestionCircleOutlined style={valueIcon} />
                            </Tooltip>
                        </p>
                        <div className={classes.checkboxGroup} style={{alignItems:'center'}}>
                            <Checkbox value='ResidualMinimo' className={checkedMin ? classes.checkboxIn : classes.checkboxOut} style={width < 800 ? {marginLeft: 10} : {marginLeft: 10}} checked={checkedMin} onChange={(e) => onChangeMin(e)}>
                                {residualPlazo?.ResidualMinimo ?? "-"}%
                                <Tooltip
                                    enterTouchDelay={0}
                                    leaveTouchDelay={6000}
                                    placement='bottom'
                                    title='Esta alternativa permite maximizar el beneficio fiscal aplicable del arrendamiento, ya que genera una amortización más rápida de los equipos arrendados.'
                                >
                                    <QuestionCircleOutlined style={checkedMin ? { ...valueIcon, color: Colors.yellow } : { ...valueIcon }} />
                                </Tooltip>
                            </Checkbox>
                            <Checkbox value='ResidualEstandar' className={checkedEst ? classes.checkboxIn : classes.checkboxOut} checked={checkedEst} onChange={(e) => onChangeMin(e)} >
                                {residualPlazo?.ResidualEstandar ?? "-"}%
                                <Tooltip
                                    enterTouchDelay={0}
                                    leaveTouchDelay={6000}
                                    placement='bottom'
                                    title='Con esta alternativa se aprovecha lo mejor de los dos mundos, permitiendo contar con un pago mensual cómodo y al mismo tiempo obteniendo beneficios fiscales aplicables al esquema de arrendamiento.'
                                >
                                    <QuestionCircleOutlined style={checkedEst ? { ...valueIcon, color: Colors.yellow } : { ...valueIcon }} />
                                </Tooltip>
                            </Checkbox>
                            <Checkbox value='ResidualMaximo' className={checkedMax ? classes.checkboxIn : classes.checkboxOut} checked={checkedMax} onChange={(e) => onChangeMin(e)}  >
                                {residualPlazo?.ResidualMaximo ?? "-"}%
                                <Tooltip
                                    enterTouchDelay={0}
                                    leaveTouchDelay={6000}
                                    placement='bottom'
                                    title='Con esta alternativa, se puede disminuir al mínimo el pago mensual de la renta, maximizando el beneficio financiero del esquema de arrendamiento.'
                                >
                                    <QuestionCircleOutlined style={checkedMax ? { ...valueIcon, color: Colors.yellow } : { ...valueIcon }} />
                                </Tooltip>
                            </Checkbox>
                        </div>
                    </Grid>
                        
                </Grid>
                
                
                
            </Row> 
            {width < 700 && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom:50}}>
                    <p style={verCotizacion ? { textAlign: 'start', width: 'fit-content', cursor: 'pointer', color: "white",fontSize:'15pt', marginTop:"-20px" } : { textAlign: 'start', marginTop: "-20px", width: 'fit-content', cursor: 'pointer', color: "white", marginBottom: 10, fontSize:'15pt',  }} onClick={() => setDesglose(!verCotizacion)}>
                        Mirar mi simulación
                        {verCotizacion ? (
                            <UpOutlined style={{ marginLeft: 1 }} />
                        ) : (
                            <DownOutlined style={{ marginLeft: 10 }} />
                        )}
                    </p>
                    {verCotizacion && (
                        <div style={{width: '100%'}}>
                            <ComponentPrice/>
                        </div>
                    )}
                </div>
            )}
        </>
    );
    
}